import { Component, inject } from '@angular/core';
import {
  ColDef,
  RowClickedEvent,
  ValueGetterParams
} from '@ag-grid-community/core';
import { ACTION_COLUMN } from '../../config/grid.config';
import { TranslateService } from '@ngx-translate/core';
import {
  getCardState,
  getOrderStatus,
  getOrderType
} from '../../utils/order.utils';
import {
  OrdersGridActionsComponent
} from './components/orders-grid-actions/orders-grid-actions.component';
import {
  NEW_ORDER_URL,
  ORDER_DETAILS_URL,
  ORDERS_URL
} from '../../config/url.config';
import { Router } from '@angular/router';
import { StoreService } from '../../services/store.service';
import { LIST_SEARCH_MODE, UserModel } from '../../model/general.model';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { userOptionLabel } from '../../utils/user.utils';
import { OrderModel } from "../../model/order.model";
import { Observable } from "rxjs";

@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
})
export class OrdersPageComponent {
  private _translate = inject(TranslateService);
  private _router = inject(Router);

  protected store = inject(StoreService);
  protected LIST_SEARCH_MODE = LIST_SEARCH_MODE;
  protected ordersListMode$ = this.store.getOrdersListMode();
  protected orders$: Observable<OrderModel[]> = this.store.orders$;
  protected columnDefs: ColDef<OrderModel>[] = [
    {
      headerName: 'NAME',
      field: 'name'
    },
    {
      headerName: 'STATUS',
      field: 'status',
      valueGetter: (value: ValueGetterParams) => this._translate.instant(getOrderStatus(value)),
    },
    {
      headerName: 'SOURCE',
      field: 'source'
    },
    {
      headerName: 'MULTI_TRACK_LINE',
      field: 'multiTrackLine',
      valueGetter: (value: ValueGetterParams) => this._translate.instant(value.data.multiTrackLine ? 'YES' : 'NO'),
    },
    {
      headerName: 'TYPE',
      field: 'dataType',
      valueGetter: (value: ValueGetterParams) => this._translate.instant(getOrderType(value)),
    },
    {
      headerName: 'FILTERS',
      field: 'filters',
      hide: true,
      valueGetter: (value: ValueGetterParams) =>  value.data.filters.map((filter: any) => `${filter.name}: ${filter.value}`),
    },
    {
      headerName: 'ASSIGNED_TO_TEAM',
      field: 'assignedTo',
      valueGetter: (value: ValueGetterParams) => value.data.assignedTo.map((user: UserModel) => userOptionLabel(user)),
    },
    {
      headerName: 'PLANNED_EXECUTION_DATE',
      field: 'plannedExecutionDate'
    },
    {
      headerName: 'TOWERS',
      field: 'towerCount',
    },
    {
      headerName: 'SPANS',
      field: 'spanCount',
    },
    // {
    //   headerName: 'CARD_STATE',
    //   valueGetter: (value: ValueGetterParams<OrderModel>) => value.data && value.data.cardState && this._translate.instant(getCardState(value.data.cardState))
    // },
    {
      headerName: ACTION_COLUMN,
      cellRenderer: OrdersGridActionsComponent,
      filter: false,
      sortable: false,
      width: 125
    }
  ];

  protected add(): void {
    void this._router.navigate([NEW_ORDER_URL])
  }

  protected rowClicked(event: RowClickedEvent) {
    if (event.data.status === 'DRAFT') {
      void this._router.navigate([ORDERS_URL, event.data.id])
      return;
    }

    void this._router.navigate([ORDER_DETAILS_URL, event.data.id])
  }

  protected changeMode(event: MatButtonToggleChange) {
    this.store.setOrdersListMode(event.value);
  }
}
